__turbopack_context__.v({
  "brandNav": "ProjectDetailLayout-module__W3CjtG__brandNav",
});
